<div class="row justify-content-center">
    <div class="col-lg-12">
        <div class="card mt-2" *ngFor="let job of jobList">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-2" style="    display: flex; flex-wrap: nowrap;flex-direction: row-reverse;
    justify-content: space-between;">
                        <img *ngIf=" job.getCompany()['logo']" src="{{baseURL +job.getCompany()['logo']}}"
                            style="width: 80%; height: 50%;" alt="">
                        <img *ngIf="!job.getCompany()['logo']" src="assets/img/default-logo.svg"
                            style="width: 80%; height: 50%;" alt="">
                    </div>
                    <div class="col-md-5">
                        <div class="company" style="left: 0;">
                            <h4 class="entreprise-name">{{ job.getCompany()['acronym'] }} <span
                                    *ngIf="typeInterface == 'entreprise'">
                                    -
                                    {{ job.getReference() }}</span></h4>
                        </div>

                        <h2 *ngIf="(typeInterface != 'candidat' && typeUser != 'candidat')" class="list-offer-title">{{
                            functionsService.wordWrap(job.getLibelle(), 50) }}</h2>
                        <a *ngIf="(typeInterface == 'candidat' && typeUser == 'candidat')"
                            [routerLink]="['/offres-emploi', job.getId()]" class="list-offer-title">{{
                            functionsService.wordWrap(job.getLibelle(), 50) }}</a>

                        <div class="address"><span class="lnr lnr-license"></span> <span
                                *ngFor="let training of job.getJobsTrainings()"
                                style="font-size: 12px; font-weight: bold; font-family: ;"> {{
                                training.getLevelOfStudy() }} en {{
                                training.getTraining()['libelle'] }} | </span> </div>
                        <div class="address">
                            <span class="lnr lnr-calendar-full"></span> {{ job.getYearOfExperience() }}
                            <span *ngIf="job.getYearOfExperience() != 'Sans expérience'">d'expériences</span>, <span
                                class="lnr lnr-map-marker"></span> {{ job.getCity() }}, {{ job.getCountry() }}
                        </div>
                        <h5 class="entreprise-adresse">{{ job.getCity() }}, {{ job.getCountry() }}</h5>


                    </div>
                    <div class="col-md-5" style="    display: flex; flex-wrap: nowrap; flex-direction: row-reverse;">
                        <div style="" *ngIf="!(typeUser )">
                            <span style="font-weight: bold;">Expire le</span>
                            <span class="badge badge-danger" *ngIf="jobIsExpired(job.getExpirationDate()) == true">{{
                                job.getExpirationDate()
                                }}</span>
                            <span class="badge badge-success" *ngIf="jobIsExpired(job.getExpirationDate()) == false">{{
                                job.getExpirationDate()
                                }}</span> <br>

                            <a style="font-weight: bold;" [routerLink]="['/offres-emploi', job.getId()]">Détails</a>
                            <div class="address d-flex">
                                <button class="mr-3 mt-2 btn btn-info">Partager</button>
                                <button class="mr-3 mt-2 btn btn-danger"
                                    (click)="addJobInBackup(job.getId())">Sauvegarder</button>
                                <a class="mt-2" [routerLink]="['/postuler', job.getId()]"><button
                                        class="btn btn-primary">Postuler</button></a>
                            </div>

                        </div>

                        <div style="margin-left: 0px;" *ngIf="(typeInterface == 'candidat' && typeUser == 'candidat')">
                            <span style="font-weight: bold;">Expire le</span>
                            <span class="badge badge-danger" *ngIf="jobIsExpired(job.getExpirationDate()) == true">{{
                                job.getExpirationDate()
                                }}</span>
                            <span class="badge badge-success" *ngIf="jobIsExpired(job.getExpirationDate()) == false">{{
                                job.getExpirationDate()
                                }}</span> <br>

                            <a style="font-weight: bold;" [routerLink]="['/offres-emploi', job.getId()]">Détails</a>
                            <div class="address d-flex">
                                <button class="mr-3 mt-2 btn btn-info"
                                    (click)="addJobInBackup(job.getId())">Partager</button>
                                <button class="mr-3 mt-2 btn btn-danger"
                                    (click)="addJobInBackup(job.getId())">Sauvegarder</button>
                                <a class="mt-2" [routerLink]="['/postuler', job.getId()]"><button
                                        class="btn btn-primary">Postuler</button></a>
                            </div>
                        </div>
                        <div style="margin-left: 0px;"
                            *ngIf="typeInterface == 'entreprise' && typeUser == 'entreprise'">
                            <div class="address mt-2">
                                <span class="badge badge-primary" *ngIf="job.getStatus() == 'En cours'">En cours
                                    d'édition</span>
                                <span class="badge badge-warning"
                                    *ngIf="job.getStatus() == 'En attente de validation'">En attente de
                                    validation</span>
                                <span class="badge badge-success" *ngIf="job.getStatus() == 'Validé'">Offre
                                    publiée</span>
                                Expire le
                                <span class="badge badge-danger"
                                    *ngIf="jobIsExpired(job.getExpirationDate()) == true">{{
                                    job.getExpirationDate() }}</span>
                                <span class="badge badge-success"
                                    *ngIf="jobIsExpired(job.getExpirationDate()) == false">{{
                                    job.getExpirationDate() }}</span>
                            </div>
                            <div class="mb-4">
                                <button class="mr-3 btn btn-primary mt-2" (click)="editJob(job)">Détails</button>
                                <button (click)="getCandidatesApplyJob(job)" class="mr-3 mt-2 btn btn-danger "
                                    style="border: 0; color: white">Candidats<span
                                        class="badge badge-danger badge-position"
                                        style="display: none;">4</span></button>
                                <button class="mr-3 mt-2 btn " style="background-color: #dc3545; color: white;"
                                    (click)="deleteJob(job)">Supprimer</button>
                            </div>
                        </div>
                        <div style="margin-left: 0px;" *ngIf="typeInterface == 'admin'">
                            <div class="address mt-2">
                                <span class="badge badge-primary" *ngIf="job.getStatus() == 'En cours'">En cours
                                    d'édition</span>
                                <span class="badge badge-warning"
                                    *ngIf="job.getStatus() == 'En attente de validation'">En attente de
                                    validation</span>
                                <span class="badge badge-success" *ngIf="job.getStatus() == 'Validé'">Offre
                                    publiée</span>
                                Expire le {{ job.getExpirationDate() }}
                            </div>
                            <div class="mb-4">
                                <button class="mr-3 mt-2 btn btn-primary" (click)="editJob(job)">Détails</button>
                                <button (click)="getCandidatesApplyJob(job)" class="mr-3 mt-2 btn bg-danger"
                                    style="border: 0; color: white">Candidats<span
                                        class="badge badge-danger badge-position"
                                        style="display: none;">4</span></button>
                                <button class="mr-3 btn btn-danger" style="padding: 5px 15px; border-radius: 5px;"
                                    (click)="deleteJob(job)">Supprimer</button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>

</div>